<template>
	<div>
		<!--{{user}}-->
		<!--1111{{user}}222-->
		{{verifysRules}}
		<el-form-item label="用户名称：" prop="verifysRules[verifys[0]]">
			<!--:prop="user[verifys[1]]">-->
			<el-input v-model.trim="userData[verifys[0]]" type="text" style="width:80%"></el-input>
		</el-form-item>
		<el-form-item label="密码：">
			<el-input v-model.trim="user.Password" type="password" style="width:80%"></el-input>
		</el-form-item>
		<el-form-item label="确认密码：">
			<el-input v-model.trim="user.Password" type="password" style="width:80%"></el-input>
		</el-form-item>
	</div>

</template>

<script>
	export default {
		data() {
			var validatePass = (rule, value, callback) => {

				if(value === '') {
					callback(new Error('请输入密码'));
				} else {
					if(this.form.checkPass !== '') {
						this.$refs.form.validateField('checkPass');
					}
					callback();
				}
			};
			var validatePass2 = (rule, value, callback) => {
				if(value === '') {
					callback(new Error('请再次输入密码'));
				} else if(value !== this.form.userPassword) {
					callback(new Error('两次输入密码不一致，请重新输入!'));
				} else {
					callback();
				}
			};
			return {
				user: this.userData
			}
		},
		props: {
			userData: {
				type: Object,
				required: true,
			},
			title: {
				type: String
			},
			verifys: {
				type: Array,
				required: true,

			},
			verifysRules: {
				type: Object,
				required: true,
			}
		}

	}
</script>